(() => {
  function getCurrencyInfo() {
    const ShopifyObj = window.Shopify || {};
    const cur = ShopifyObj.currency || {};
    let active = cur.active || null;
    let rate = cur.rate || 1;

    if (typeof rate === 'string') rate = parseFloat(rate);
    if (!rate || Number.isNaN(rate)) rate = 1;

    return { active, rate };
  }

  function getCurrencySymbol(code) {
    try {
      const parts = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
      }).formatToParts(0);

      const p = parts.find((x) => x.type === 'currency');
      return p ? p.value : '';
    } catch {
      return '';
    }
  }

  function formatMoney(amount, currencyCode) {
    // keep 2 decimals, thousands separators
    const fixed = (Math.round(amount * 100) / 100).toFixed(2);
    const chunks = fixed.split('.');
    chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const pretty = chunks.join('.');

    const symbol = getCurrencySymbol(currencyCode);

    // ✅ requested format: "$11.99 AUD" (space before code)
    return `${symbol}${pretty} ${currencyCode}`;
  }

  function convertMoneyNodes(root = document) {
    const { active, rate } = getCurrencyInfo();
    if (!active) return;

    root.querySelectorAll('.js-pt-money[data-base-cents]').forEach((node) => {
      const baseCentsStr = node.getAttribute('data-base-cents');
      if (!baseCentsStr) return;

      const baseCents = parseInt(baseCentsStr, 10);
      if (Number.isNaN(baseCents)) return;

      const baseUnits = baseCents / 100;
      const activeUnits = baseUnits * rate;

      node.textContent = formatMoney(activeUnits, active);
    });
  }

  function initToggle(root = document) {
    const petsBtn = root.querySelector('.pricing__toggle-btn--pets');
    const farmBtn = root.querySelector('.pricing__toggle-btn--farm');
    const cards = root.querySelectorAll('.pricing__card');
    const tables = root.querySelectorAll('.pricing__table__inner');

    // If your toggle buttons are commented out, just exit quietly.
    if (!petsBtn || !farmBtn) return;

    const switchView = (type) => {
      petsBtn.classList.toggle('is-active', type === 'pet_plan');
      farmBtn.classList.toggle('is-active', type === 'farm_plan');

      cards.forEach((card) => {
        card.style.display = card.dataset.planType === type ? 'block' : 'none';
      });

      tables.forEach((tbl) => {
        const isActive = tbl.classList.contains(
          type === 'pet_plan' ? 'pricing__table__pets' : 'pricing__table__farm'
        );
        tbl.classList.toggle('is-active', isActive);
      });

      // re-run currency conversion (just in case)
      convertMoneyNodes(root);
    };

    // avoid double-binding
    if (!petsBtn.__ptBound) {
      petsBtn.__ptBound = true;
      petsBtn.addEventListener('click', () => switchView('pet_plan'));
    }
    if (!farmBtn.__ptBound) {
      farmBtn.__ptBound = true;
      farmBtn.addEventListener('click', () => switchView('farm_plan'));
    }

    switchView('pet_plan');
  }

  function initPricingTable(root = document) {
    convertMoneyNodes(root);
    initToggle(root);

    // short retry loop in case Shopify.currency.rate arrives late
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      convertMoneyNodes(root);
      if (tries >= 10) clearInterval(t);
    }, 250);
  }

  window.PURRZ = window.PURRZ || {};
  window.PURRZ.initPricingTable = initPricingTable;

  document.addEventListener('DOMContentLoaded', () => {
    // init any pricing tables already on page
    initPricingTable(document);
  });

  // optional hooks if your switcher dispatches events
  document.addEventListener('currency:changed', () => initPricingTable(document));
  document.addEventListener('tl:applied', () => initPricingTable(document));
})();
